import axios from "../../../../api/axios";

import { ProfessionalConnectionsResponse } from "../types/professionalConnections.types";

export const getUserProfessionalConnections = async (userId: string): Promise<ProfessionalConnectionsResponse> => {
  try {
    const response = await axios.get<ProfessionalConnectionsResponse>(`users/${userId}/professional-connections`);
    return response.data;
  } catch (err) {
    throw new Error(`Failed to fetch professional connections: ${(err as Error).message}`);
  }
};
